// import { makeStyles } from "@mui/styles";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
  searchBar: () => ({
    "& .MuiInputBase-root": {
      borderRadius: "25px",
      backgroundColor: "#ffffff !important",
      height: "48px",
      marginTop: "2px",
      paddingLeft: "10px",
      "& input": {
        height: "1em !important",
        height: "35px",
      },
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ccc !important",
      borderWidth: "0 !important"
    },
  }),
});


export default useStyles;
